export default "__VITE_ASSET__01d788e0__"